import { Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/observable/throw';
import { Subscription } from 'rxjs/Subscription';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ENDPOINTKILLTOKEN } from '../../../features/creacion-clave/creacion-clave.config';

@Injectable()
export class ExpiraTokenService implements OnDestroy {

  public expirado: Subscription;

  constructor(private http: HttpClient) { }

  killToken(rut: string): Observable<any> {
    const data = {
      'rut': rut
    };
    console.log("Expira token")
    return this.http.post(ENDPOINTKILLTOKEN, data, { observe: 'response' } )
      .map((res: HttpResponse<any>) => {
        if (res.ok) {
          return [{ status: res.status, json: res }];
        }
      }).catch((error: any) => {
        return [{ status: error.status, json: error }];
      });
  }

  expiraToken(rut: string) {
    console.log("Expira token")
    this.expirado = this.killToken(rut)
      .subscribe(
        ((Response: any) => {
          if (Response[0]) {
            if (Response[0].status === 200) {
              return;
            }
          } else {
            return;
          }
        }),
      );
  }

  ngOnDestroy() {
    if (this.expirado) {
      this.expirado.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/expToken/expira-token.service.ts